var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgIc40SocialYoutube = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 40,
  height: 40,
  fill: "none",
  viewBox: "0 0 40 40"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentcolor",
  fillRule: "evenodd",
  d: "M35.427 9.636a4.357 4.357 0 0 1 1.125 1.942c1.144 4.606.88 11.882.022 16.666a4.356 4.356 0 0 1-3.067 3.067c-2.688.733-13.51.733-13.51.733s-10.823 0-13.512-.733a4.355 4.355 0 0 1-3.066-3.067c-1.152-4.586-.836-11.866-.023-16.644a4.356 4.356 0 0 1 3.067-3.067c2.689-.733 13.511-.755 13.511-.755s10.822 0 13.511.733a4.356 4.356 0 0 1 1.942 1.125Zm-9.92 10.275-8.977 5.2v-10.4l8.977 5.2Z",
  clipRule: "evenodd"
})));
export default SvgIc40SocialYoutube;